import React, { useEffect } from 'react'
import './../assets/css/sessionexpired.css'
const SessionExpired = () => {
    useEffect(()=>{
        localStorage.clear()
    },[])
    return (
        <>
        <div className='session_expired'>
            <div className='row'>
                <div className='col-7 m-auto p-3 text-center'>
                    <h3>
                        Your session has expired!
                    </h3>
                    <p>You are required to login since you have been inactive for the past few hours.</p>
                    <p>You will be redirected to our login page automatically.</p>
                    <a className='text-primary sess_exp_a' href='/'>Login Now <i className="fa fa-arrow-right fs-12" aria-hidden="true"></i></a>
                </div>
                <div className='col-4 text-left'>
                    <img src='./PNF2.png' className='w-100 h-100'></img>
                </div>
            </div>
            </div>
        </>
    )
}

export default SessionExpired